/** Espelha a API (offline-page): prioriza `paginas2` quando tem itens. */
export function effectiveImagePageCountFromApiChapter(data: {
  paginas?: unknown[] | null;
  paginas2?: unknown[] | null;
  total_paginas?: number;
  cap_total_paginas?: number;
  _count?: { paginas?: number } | null;
}): number {
  if (typeof data.total_paginas === 'number' && data.total_paginas > 0) {
    return data.total_paginas;
  }
  if (typeof data.cap_total_paginas === 'number' && data.cap_total_paginas > 0) {
    return data.cap_total_paginas;
  }
  if (typeof data._count?.paginas === 'number' && data._count.paginas > 0) {
    return data._count.paginas;
  }
  const p2 = Array.isArray(data.paginas2) ? data.paginas2.length : 0;
  const p1 = Array.isArray(data.paginas) ? data.paginas.length : 0;
  return p2 > 0 ? p2 : p1;
}

/** Mesma regra do token offline na API. */
export function chapterApiPayloadSupportsOfflineDownload(data: {
  tipo?: string | null;
  cap_tipo?: string | null;
  paginas?: unknown[] | null;
  paginas2?: unknown[] | null;
  total_paginas?: number;
  cap_total_paginas?: number;
  _count?: { paginas?: number } | null;
  cap_uuid?: string | null;
  uuid?: string | null;
  cap_conteudo_texto?: string | null;
  conteudo_texto?: string | null;
}): boolean {
  const tipo = String(data.tipo ?? data.cap_tipo ?? 'imagem').toLowerCase();
  if (tipo === 'imagem') {
    if (effectiveImagePageCountFromApiChapter(data) > 0) return true;
    // Alguns capítulos vêm sem contagem mas com JSON CDN (cap_uuid/uuid).
    return Boolean(data.cap_uuid || data.uuid);
  }
  if (tipo === 'texto' || tipo === 'markdown' || tipo === 'html') {
    const text = String(data.cap_conteudo_texto ?? data.conteudo_texto ?? '').trim();
    return text.length > 0;
  }
  return false;
}
